import { Injectable } from '@angular/core';
import { ApiClass } from '@data/class/api-class';
import { environment } from '@env/environment';
import { Observable, catchError, map, of } from 'rxjs';
import { IDrippingListResponse } from '../../interfaces/api-response.interface';
import { IResponseArray } from '@data/interfaces/iresponseArray.interface';

/**
 * Servicio API para gestión de comunicaciones del módulo Dripping
 */
@Injectable({
  providedIn: 'root'
})
export class ApiCommunicationsService extends ApiClass {

  constructor() {
    super();
    this.path = 'dripping/emails';
  }

  /**
   * NOTA: Según documentación, NO existe endpoint POST /dripping/emails
   * El historial de emails se obtiene por lease: GET /dripping/emails/history/:leaseId
   * Este método retorna vacío por defecto hasta implementar funcionalidad correcta
   */
  getAll(page = 1, limit = 10, filters = {}): Observable<IDrippingListResponse> {
    const response: IDrippingListResponse = { 
      error: false, 
      msg: 'Communications requiere filtro por leaseId. Use getHistoryByLease(leaseId)', 
      data: {
        data: [],
        total: 0
      },
      status: 200,
      page: 1, 
      itemsByPage: 10, 
      totalItems: 0 
    };

    // Retornar respuesta vacía inmediatamente sin hacer petición
    return of(response);
  }
  
  /**
   * Obtener historial de emails por lease
   * @param leaseId - ID del lease
   * @returns Observable con historial de emails
   */
  getHistoryByLease(leaseId: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}dripping/emails/history/${leaseId}`);
  }

  /**
   * Obtener detalle de email por ID
   * @param id - ID del email
   * @returns Observable con datos del email
   */
  getById(id: string): Observable<any> {
    return this.getCollection(id);
  }

  /**
   * Obtener tracking de email específico
   * @param id - ID del email
   * @returns Observable con eventos de tracking
   */
  getTracking(id: string): Observable<any> {
    return this.getCollection(`${id}/tracking`);
  }

  /**
   * Reenviar email fallido o rebotado
   * @param id - ID del email a reenviar
   * @returns Observable con respuesta del reenvío
   */
  resend(id: string): Observable<any> {
    return this.postCollection({}, `${id}/resend`);
  }
}
